import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import useAppUser from 'hooks/useAppUser';
import {
  GetGuestReviewTemplatesResponse,
  GuestReviewTemplate,
} from 'models/automation/Reviews';
import API from 'services/API';

export const GUEST_REVIEW_TEMPLATES_BASE_QUERY_KEY = 'guest-review-templates';

type ReactQueryOptions = Omit<
  UseQueryOptions<GuestReviewTemplate[]>,
  'queryKey' | 'queryFn'
>;

type UseFetchGuestReviewTemplatesArgs = ReactQueryOptions;

const useFetchGuestReviewTemplates = ({
  enabled = true,
  ...options
}: UseFetchGuestReviewTemplatesArgs = {}) => {
  const { agencyUid } = useAppUser();

  return useAppQuery<GuestReviewTemplate[]>({
    queryKey: [GUEST_REVIEW_TEMPLATES_BASE_QUERY_KEY, 'get-all', agencyUid],
    queryFn: async () => {
      const response = await API.get<GetGuestReviewTemplatesResponse>(
        '/api/internal/predefined-hosts-reviews',
        {
          params: {
            agencyUid,
          },
        },
      );

      return response.data.predefinedHostsReviews;
    },
    staleTime: 30000,
    keepPreviousData: true,
    enabled,
    ...(options ?? {}),
  });
};

export default useFetchGuestReviewTemplates;
